import { HeadCellSortState } from '@foradevelopment/fora-ui';

import { PayHistoryTableSortId } from '../../../common/types';

export type PayHistorySortState = typeof defaultPayHistoryListSortState;
export type PayHistorySortIdKeys = keyof typeof defaultPayHistoryListSortState;

export const defaultPayHistoryListSortState = {
  [PayHistoryTableSortId.Organization]: HeadCellSortState.None,
  [PayHistoryTableSortId.Id]: HeadCellSortState.None,
  [PayHistoryTableSortId.FirstName]: HeadCellSortState.None,
  [PayHistoryTableSortId.LastName]: HeadCellSortState.None,
  [PayHistoryTableSortId.Period]: HeadCellSortState.None,
  [PayHistoryTableSortId.GrossSalary]: HeadCellSortState.None,
};
